(() => {
  const root = document.querySelector('.tx-refresh');
  if (!root) return;
  const quizUrl = (params = {}) => {
    const url = new URL('/pages/quiz', location.origin);
    new URLSearchParams(location.search).forEach((value, key) => { if (!['step', 'age_group', 'customer_posted'].includes(key)) url.searchParams.set(key, value); });
    Object.entries(params).forEach(([key, value]) => url.searchParams.set(key, value));
    return url.pathname + url.search;
  };
  root.querySelectorAll('[data-start-quiz]').forEach(button => button.addEventListener('click', () => { location.href = quizUrl(); }));
  root.querySelectorAll('[data-quiz-age]').forEach(button => button.addEventListener('click', () => {
    const next = quizUrl({ step: 'intro', age_group: button.dataset.quizAge });
    if (location.pathname === '/pages/quiz' && document.querySelector('[data-testorise-quiz]')?.dataset.quizReady === 'true') {
      history.pushState({}, '', next);
      window.dispatchEvent(new PopStateEvent('popstate'));
      window.scrollTo(0, 0);
      return;
    }
    location.href = next;
  }));
  root.querySelectorAll('[data-scroll-offer]').forEach(button => button.addEventListener('click', () => root.querySelector('#products')?.scrollIntoView({ behavior: 'smooth' })));
  root.querySelectorAll('button[aria-controls]').forEach(button => {
    const panel = root.querySelector(`[id="${CSS.escape(button.getAttribute('aria-controls'))}"]`);
    if (!panel) return;
    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(open));
      panel.classList.toggle('is-open', open);
    });
  });
  root.querySelectorAll('[data-menu-toggle]').forEach(button => button.addEventListener('click', () => {
    const open = button.getAttribute('aria-expanded') !== 'true';
    button.setAttribute('aria-expanded', String(open));
    button.closest('[class*=header__Content]')?.querySelector('[class*=header__Navigation]')?.classList.toggle('is-open', open);
  }));
  const facts = root.querySelector('.trf-dialog');
  root.querySelector('[data-formula-facts]')?.addEventListener('click', () => facts?.showModal());
  root.querySelector('[data-formula-close]')?.addEventListener('click', () => facts?.close());
  facts?.addEventListener('click', event => { if (event.target === facts) facts.close(); });
  const gallery = root.querySelector('[data-home-gallery]');
  if (gallery) {
    const slides = [...gallery.querySelectorAll('[data-home-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-home-thumb]')];
    let index = 0;
    const show = next => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== index; });
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === index)));
      gallery.querySelector('[data-home-position]').textContent = `${index + 1} / ${slides.length}`;
    };
    gallery.querySelector('[data-home-prev]').addEventListener('click', () => show(index - 1));
    gallery.querySelector('[data-home-next]').addEventListener('click', () => show(index + 1));
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
  }
  // Load and loop approved silent clips only while visible; native controls remain available.
  const reviewVideos = root.querySelectorAll('[data-review-video]');
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const videoObserver = new IntersectionObserver(entries => entries.forEach(({ target, isIntersecting }) => {
      if (isIntersecting) {
        target.muted = true;
        target.play().catch(() => {});
      } else {
        target.pause();
      }
    }), { threshold: 0.4 });
    reviewVideos.forEach(video => videoObserver.observe(video));
  }
  const timer = root.querySelector('[class*=timer__Root]');
  if (timer) {
    const tick = () => {
      const now = new Date(); const end = new Date(now); end.setHours(24, 0, 0, 0);
      const seconds = Math.floor((end - now) / 1000);
      timer.textContent = [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60].map(n => String(n).padStart(2, '0')).join(':');
    };
    tick(); setInterval(tick, 1000);
  }
})();
